import ServicePhoneRoute from "../../UrlRoute/ServicePhone";

export const GET_ALL_SIP_USERS = "GET_ALL_SIP_USERS";

// ==================================== Get Sip Users ======================================//
export const SipUsers = (params) => {
  return async (dispatch) => {
    return await ServicePhoneRoute.SipUsers(params)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: GET_ALL_SIP_USERS,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: GET_ALL_SIP_USERS,
            payload: {
              data: response.data,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: GET_ALL_SIP_USERS,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: GET_ALL_SIP_USERS,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Get Sip Users ======================================//
